import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';

import CloseIcon from '@/assets/svg/bx-x.svg?react';
import { InputGroupButton } from '@/components/Form/inputs';
import { cn } from '@/lib/utils';

import { pickerTriggerIconSizeClasses } from '../pickerPrimitiveStyles';
import { useComboboxContext } from './ComboboxContext';

export type ComboboxClearProps = ComboboxPrimitive.Clear.Props;

const ComboboxClear = ({ className, ...props }: ComboboxClearProps) => {
  const { size } = useComboboxContext();

  return (
    <ComboboxPrimitive.Clear
      data-slot="combobox-clear"
      className={cn(pickerTriggerIconSizeClasses[size], className)}
      render={
        <InputGroupButton variant="ghost" size="icon-small" className="size-6 rounded-xs p-0">
          <CloseIcon className="pointer-events-none" />
        </InputGroupButton>
      }
      {...props}
    />
  );
};

export default ComboboxClear;
